import React from "react";

const Navbar = () => {
  return (
    <>
      {/* Mobile */}
      <nav className="lg:hidden fixed z-50 left-1/2 top-[18px] -translate-x-1/2 w-[min(92vw,620px)] h-[42px] px-4 bg-white/85 shadow-[0px_4px_8.7px_rgba(0,0,0,0.32)] backdrop-blur-[7.65px] rounded-[88px] flex items-center justify-between">
        <img
          src="/logo.png"
          alt="Logo"
          className="h-[26px] w-[26px] flex-shrink-0"
        />
        <a
          href="https://www.change.org/p/mandate-tethered-plastic-bottle-caps-in-india/"
          target="_blank"
          rel="noopener noreferrer"
          className="font-inter font-medium text-[clamp(10px,3vw,12.5px)] leading-[18px] underline decoration-1 underline-offset-4 text-black uppercase tracking-[0.05em] truncate ml-2"
        >
          Sign The Petition
        </a>
      </nav>

      {/* Desktop wrapper */}
      <nav className="hidden lg:block fixed inset-x-0 top-[44px] z-50">
        {/* lg → xl */}
        <div
          className="xl:hidden flex items-center justify-between h-[66px] px-8 bg-white/85 shadow-[0px_4px_8.7px_rgba(0,0,0,0.32)] backdrop-blur-[7.65px] rounded-[88px]"
          style={{
            left: "64px",
            right: "64px",
            position: "absolute",
          }}
        >
          <img
            src="/logo.png"
            alt="Logo"
            className="h-[clamp(34px,2.8vw,40px)] w-[clamp(34px,2.8vw,40px)] flex-shrink-0"
          />
          <a
            href="https://www.change.org/p/mandate-tethered-plastic-bottle-caps-in-india/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-inter font-medium text-[clamp(14px,1vw,16px)] leading-[1.4] underline decoration-1 underline-offset-4 text-black uppercase tracking-[0.05em] whitespace-nowrap"
          >
            Sign The Petition
          </a>
        </div>

        {/* xl+ */}
        <div
          className="hidden xl:flex items-center justify-between h-[66px] px-8 bg-white/85 shadow-[0px_4px_8.7px_rgba(0,0,0,0.32)] backdrop-blur-[7.65px] rounded-[88px]"
          style={{
            left: "124px",
            right: "124px",
            position: "absolute",
          }}
        >
          <img
            src="/logo.png"
            alt="Logo"
            className="h-[40px] w-[40px] flex-shrink-0"
          />
          <a
            href="https://www.change.org/p/mandate-tethered-plastic-bottle-caps-in-india/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-inter font-medium text-[16px] leading-[1.4] underline decoration-1 underline-offset-4 text-black uppercase tracking-[0.05em] whitespace-nowrap"
          >
            Sign The Petition
          </a>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
